import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth"
import { getCachedAuthSession } from "../utils/userAttributesCache";
import { Loader, View } from "@aws-amplify/ui-react";

interface AdminRouteProps {
  children: ReactNode;
}

function AdminRoute({ children }: AdminRouteProps) {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    checkAdminAccess();
  }, []);

  const checkAdminAccess = async () => {
    try {
      await getCurrentUser();
      const session = await getCachedAuthSession();

      // Get groups from JWT token
      const idToken = session.tokens?.idToken;
      const groups = idToken?.payload["cognito:groups"] as string[] | undefined;

      const hasAdminAccess = groups?.includes("admin") || false;

      setIsAdmin(hasAdminAccess);
    } catch {
      setIsAdmin(false);
    }
  };

  if (isAdmin === null) {
    return (
      <View padding="2rem" textAlign="center">
        <Loader size="large" />
      </View>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}

export default AdminRoute;
